import { GameVars } from "../../GameVars";
import { GridContainer } from "./GridContainer";

export class Cell extends Phaser.GameObjects.Container {

    public static f = 0;

    private static SHARD_SPEED = [
        {x: -3.5, y: -4.5},
        {x: 3.5, y: -4.5},
        {x: 3.5, y: 0},
        {x: 0, y: 0},
        {x: -3.5, y: 0}
    ];

    public p: {c: number, r: number};
    public specialCell: boolean;
    public specialCellType: number;
    public disappearing: boolean;

    private cellImg: Phaser.GameObjects.Image;    
    private cellOff: Phaser.GameObjects.Image;
    private color: number;
    private shards: {v: {x: number, y: number, a: number}, img: Phaser.GameObjects.Image, f: number, framesIdle: number} [];
    private exploding: boolean;
    private gridContainer: GridContainer;
    private glow: Phaser.GameObjects.Sprite;
    private blurredGem: Phaser.GameObjects.Image;
    private lives: number;
    private livesLabel: Phaser.GameObjects.Text;
    private destructibleImgUL: Phaser.GameObjects.Image;
    private destructibleImgDL: Phaser.GameObjects.Image;
    private destructibleImgUR: Phaser.GameObjects.Image;
    private destructibleImgDR: Phaser.GameObjects.Image;
    private destructibleImgContainer: Phaser.GameObjects.Container;
    private circleNumberImg: Phaser.GameObjects.Image;
    private changeToNormalCell: boolean;
    private v_y: number;

    constructor(scene: Phaser.Scene, p: {c: number, r: number}, color: number, gridContainer: GridContainer, lives ?: number) {
        
        super(scene);

        this.p = p;
        this.color = color;
        this.gridContainer = gridContainer;
        this.exploding = false;
        this.specialCell = false;
        this.specialCellType = null;

        this.disappearing = false;
        this.changeToNormalCell = false;
        // la gema blurreada
        this.blurredGem = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "gem_00_light");
        this.blurredGem.setScale(.75);
        this.blurredGem.alpha = .55;
        this.blurredGem.visible = false;
        this.add(this.blurredGem);

        let cellTextureName = this.color === -1 ? "gem_unbreakable" : "gem_0" + this.color;
        this.cellImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", cellTextureName);
        this.add(this.cellImg);

        this.cellOff = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "gem_00");
        this.cellOff.alpha = 0;
        this.add(this.cellOff);

        if (lives > 1) {  

            this.lives = lives;

            this.circleNumberImg = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "circle_items");
            this.circleNumberImg.setScale(1.25);
            this.add(this.circleNumberImg);

            this.livesLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, this.lives.toString(), { fontFamily: "Oswald-DemiBold", fontSize: "20px", color: "#f0faf9"});
            this.livesLabel.setOrigin(.5);
            this.add(this.livesLabel);

            this.destructibleImgContainer = new Phaser.GameObjects.Container(this.scene);            
            this.destructibleImgDL = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "down_left_frame");
            this.destructibleImgContainer.add(this.destructibleImgDL);
            this.destructibleImgDR = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "down_right_frame");
            this.destructibleImgContainer.add(this.destructibleImgDR);
            this.destructibleImgUR = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "up_right_frame");
            this.destructibleImgContainer.add(this.destructibleImgUR);
            this.destructibleImgUL = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "up_left_frame");
            this.destructibleImgContainer.add(this.destructibleImgUL);
            this.add(this.destructibleImgContainer);

        } else {
            this.lives = 1;
        }
        this.v_y = 1;

        this.setScale(.9);

        this.scene.tweens.add({
            targets: this,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 100
        });

        this.shards = [];

        if (this.color !== -1) {

            for (let i = 0; i < 5; i ++) {

                const shard = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "gem_0" + this.color + "_shard_0" + (i + 1));
                shard.visible = false;
                this.add(shard);
    
                const vx = Cell.SHARD_SPEED[i].x + .75 - 1.5 * Math.random();
                const vy = Cell.SHARD_SPEED[i].y + .75 - 1.5 * Math.random();
                const a = 3 - 6 * Math.random();
    
                this.shards.push({
                    v: {x: vx, y: vy, a: a},
                    img: shard, 
                    f: 0,
                    framesIdle: Math.floor(Math.random() * 8 + 5)
                });
            }
    
            this.glow = new Phaser.GameObjects.Sprite(this.scene, 0, 0, "texture_atlas_1", "glare_01");
            this.glow.visible = false;
            this.scene.add.existing(this.glow);
            this.add(this.glow);
        } else {
            this.glow = null;
        }
    }

    public update(): void {

        if (this.exploding) {

            for (let i = 0; i < this.shards.length; i ++) {

                const shard = this.shards[i];

                shard.f ++;

                if (shard.f >= shard.framesIdle) {

                    shard.v.y += .5;   // LA GRAVEDAD
                    shard.img.x += shard.v.x;
                    shard.img.y += shard.v.y;
    
                    shard.img.angle += shard.v.a;
    
                    let s = shard.img.scaleX;
                    s *= .95;
                    shard.img.scaleX = s;
                    shard.img.scaleY = s;
                }
            }

        } else {

            if (this.color !== -1 && !this.gridContainer.markingPossibleLinesAndColumns && Math.random() > .9995) {
                this.shine();
            }
        }

        if (this.changeToNormalCell) {

            this.v_y += .35; 

            this.destructibleImgDL.x += -.5;
            this.destructibleImgDL.y += this.v_y;
    
            this.destructibleImgDL.angle += -.7;

            this.destructibleImgUL.x += -.5;
            this.destructibleImgUL.y += this.v_y;
    
            this.destructibleImgUL.angle += -.7;

            this.destructibleImgUR.x += .5;
            this.destructibleImgUR.y += this.v_y;
    
            this.destructibleImgUR.angle += .7;
    
            this.destructibleImgDR.x += .7;
            this.destructibleImgDR.y += this.v_y;
    
            this.destructibleImgDR.angle += 2;
 
            this.circleNumberImg.angle += 10;

            this.livesLabel.angle = this.circleNumberImg.angle;
            this.livesLabel.alpha = this.circleNumberImg.alpha;

            this.destructibleImgContainer.alpha -= 0.02;
        }
    }

    public onMatch(n: number, isCombo: boolean, comboSize?: number): void {

        if (this.disappearing) {
            return;
        }
        
        const matchGemColor = GameVars.selectedBlock.color;
        let delay = isCombo ? 750 * n + 1000 : 750 * n + 50;
        

        if (this.lives === 1) {
            this.disappearing = true;
            this.glow.destroy(); 
        }
        
        if (this.specialCell) {
            
            this.gridContainer.removeCell(this);

        } else {

            this.breakCell(delay, matchGemColor, false);
        }
    }

    public breakCell(delay: number, matchGemColor: number, manual: boolean): void {

        if (this.lives > 1) {

            this.lives --;
            
            if (this.lives === 1) {
                this.unlockCell(delay);
            } else {
                this.scene.tweens.add({
                    targets: this.destructibleImgContainer,
                    scaleX: .75,
                    scaleY: .75,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500,
                    onComplete: function(): void {
                        this.scene.tweens.add({
                            targets: this.destructibleImgContainer,
                            scaleX: 1,
                            scaleY: 1,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 500,
                        });
                    },
                    onCompleteScope: this
                });

                this.scene.tweens.add({
                    targets: this.livesLabel,
                    scaleX: 1.5,
                    scaleY: 1.5,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 500,
                    onComplete: function(): void {
                        
                        this.livesLabel.text = this.lives.toString();
                        this.scene.tweens.add({
                            targets: this.livesLabel,
                            scaleX: 1,
                            scaleY: 1,
                            ease: Phaser.Math.Easing.Cubic.Out,
                            duration: 500,
                        });
                    },
                    onCompleteScope: this
                });
            }
            
            this.setScale(1);

        }  else {

            this.lives --;
            this.brokenCellAnim(matchGemColor, delay, manual);
        }
    }

    public markHover(): void {

        this.cellImg.setFrame("gem_0" + GameVars.selectedBlock.color);
        this.cellOff.setFrame("gem_0" + GameVars.selectedBlock.color);
    }

    public unMarkHover(): void {

        if (this.color !== -1) {
            this.cellImg.setFrame("gem_0" + this.color);
            this.cellOff.setFrame("gem_00");
        }        
    }

    public onGameOver(): void {

        if (this.disappearing || this.color === -1) {
            return;
        }

        const t = Math.random() * 750 + 150;
        
        this.unMarkHover(); 
        
        this.scene.tweens.add({
            targets: this.cellOff,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 750,
            delay: t
        });

        this.scene.tweens.add({
            targets: this.cellImg,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 750,
            delay: t
        });

        this.scene.tweens.add({
            targets: this,
            scaleX: .85,
            scaleY: .85,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 750,
            delay: t
        });
    }

    private brokenCellAnim(matchGemColor: number, delay: number, manual: boolean): void {
        
        this.x += 2.5 - 5 * Math.random();
        this.y += 2.5 - 5 * Math.random();

        this.angle = 2 - 4 * Math.random();
        
        if (this.glow) {
            this.glow.destroy();
            this.glow = null;
        }

        this.setScale(1);

        this.cellImg.setFrame("gem_0" + matchGemColor);
        this.cellOff.setFrame("gem_0" + matchGemColor);

        this.scene.time.delayedCall(delay - 50, function(): void {
            this.cellImg.blendMode = Phaser.BlendModes.OVERLAY;
            this.cellImg.setFrame("gem_shine");
            this.cellOff.blendMode = Phaser.BlendModes.OVERLAY;
            this.cellOff.setFrame("gem_shine");
        }, [], this);  

        this.scene.time.delayedCall(delay, function(): void {

            this.exploding = true;    

            this.cellImg.visible = false;
            this.cellOff.visible = false;

            for (let i = 0; i < this.shards.length; i++) {
                this.shards[i].img.visible = true;
                this.shards[i].img.setFrame("gem_0" + matchGemColor + "_shard_0" + (i + 1));
            }

        }, [], this);    

        // la gema blurreada
        this.blurredGem.visible = true;
        this.blurredGem.setFrame("gem_0" + matchGemColor + "_light");

        this.scene.tweens.add({
            targets: this.blurredGem,
            alpha: 0,
            scaleX: 1.2,
            scaleY: 1.2,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000,
            delay: delay + 200,
            onComplete: function(): void {
                if (!manual) {
                    this.gridContainer.removeCell(this);
                }
            },
            onCompleteScope: this
        });
    }
    
    private shine(): void {

        if (this.disappearing) {
            return;
        }

        if (this.glow) {

            this.glow.visible = true;

            this.glow.anims.play("shine");
            this.glow.on("animationcomplete", function(): void {
                if (this.glow) {
                    this.glow.visible = false;
                }
            }, this);
        }       
    }
    
    private unlockCell(delay: number): void {

        this.changeToNormalCell = true;

        this.scene.tweens.add({
            targets: this.circleNumberImg,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000,
            delay: delay,
            onComplete: function(): void {
                this.destructibleImgContainer.visible = false;
                this.livesLabel.visible = false;
                this.circleNumberImg.visible = false;
                this.changeToNormalCell = false;
            },
            onCompleteScope: this
        });
    }
}
